import { __awaiter } from "tslib";
import { getToken } from 'pathfinder/store/selectors';
import store from 'pathfinder/store/store';
import { getCookieByName } from 'utils/getCookieByName';
const COOKIE_VERIFY_KEY = 'pfh1';
const ONE_WEEK_SECONDS = 604800;
function checkActionsInSSDK(moduleType) {
    return __awaiter(this, void 0, void 0, function* () {
        const currentTimeInMs = Date.now();
        return (yield window.SilverSurferSDK.getActions(getToken(store.getState()), window.SilverSurferSDK.ACTION.IMPRESSION)).filter((impression) => {
            if (impression.name !== moduleType) {
                return false;
            }
            // is within a week
            return currentTimeInMs - impression.time < ONE_WEEK_SECONDS;
        });
    });
}
/** Set a tiny cookie to one week to verify SSDK is accurate over a one week period */
export function setHealthCheckCookieCount() {
    const healthCheckCookie = getCookieByName(COOKIE_VERIFY_KEY);
    const cookieValue = healthCheckCookie ? parseInt(healthCheckCookie, 10) + 1 : 1;
    // TODO: Important: this is a temporary solution and should be removed after Rules Engine release, as we aren't always on the fandom.com domain
    // Disabled for now, as we don't want to set the cookie
    // eslint-disable-next-line regex/invalid
    // document.cookie = `${COOKIE_VERIFY_KEY}=${cookieValue}; max-age=${ONE_WEEK_SECONDS}; ${
    // 	isLocalHost() ? '' : 'domain=.fandom.com'
    // }; path=/`;
}
export default function healthCheckModule({ track, log, moduleType }) {
    // setHealthCheckCookieCount();
    const dailyCookieCountVal = getCookieByName(COOKIE_VERIFY_KEY);
    // Validate cookie to impression count
    checkActionsInSSDK(moduleType).then((result) => {
        if (!dailyCookieCountVal) {
            log.debug('no cookie - this should never happen');
            track({ action: 'error', label: 'no cookie set' });
            return;
        }
        const cookieCount = parseInt(dailyCookieCountVal, 10);
        const ssdkActionCount = result.length;
        log.debug(`cookieCount: ${cookieCount}, ssdkActionCount: ${ssdkActionCount}`);
        if (ssdkActionCount === cookieCount) {
            track({ action: 'validated', label: 'equal' });
        }
        else {
            track({ action: 'invalidated', label: `cookie: ${cookieCount} | ssdk: ${ssdkActionCount}` });
        }
    });
}
